import React from 'react';
function About(){
    return <>
    <div className="Name">About</div>
    </>
}
export default About;